/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as GuidedBookingRouteImport } from './routes/guidedBooking'
import { Route as BookingRouteImport } from './routes/booking'
import { Route as SecureRouteRouteImport } from './routes/secure/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SecureIndexRouteImport } from './routes/secure/index'
import { Route as MydocsIndexRouteImport } from './routes/mydocs/index'
import { Route as SecureVerifyAccountRouteImport } from './routes/secure/verifyAccount'
import { Route as SecureUpdatePasswordRouteImport } from './routes/secure/updatePassword'
import { Route as SecureResetPasswordRouteImport } from './routes/secure/resetPassword'
import { Route as SecureLoginRouteImport } from './routes/secure/login'
import { Route as FormsIdRouteImport } from './routes/forms/$id'
import { Route as SecurePortalRouteRouteImport } from './routes/secure/portal/route'
import { Route as SecurePortalIndexRouteImport } from './routes/secure/portal/index'
import { Route as SeemeSessionIdAttendeeIdRouteImport } from './routes/seeme/$sessionId.$attendeeId'
import { Route as FormsPreviewIdRouteImport } from './routes/forms/preview/$id'

const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const GuidedBookingRoute = GuidedBookingRouteImport.update({
  id: '/guidedBooking',
  path: '/guidedBooking',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingRoute = BookingRouteImport.update({
  id: '/booking',
  path: '/booking',
  getParentRoute: () => rootRouteImport,
} as any)
const SecureRouteRoute = SecureRouteRouteImport.update({
  id: '/secure',
  path: '/secure',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SecureIndexRoute = SecureIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SecureRouteRoute,
} as any)
const MydocsIndexRoute = MydocsIndexRouteImport.update({
  id: '/mydocs/',
  path: '/mydocs/',
  getParentRoute: () => rootRouteImport,
} as any)
const SecureVerifyAccountRoute = SecureVerifyAccountRouteImport.update({
  id: '/verifyAccount',
  path: '/verifyAccount',
  getParentRoute: () => SecureRouteRoute,
} as any)
const SecureUpdatePasswordRoute = SecureUpdatePasswordRouteImport.update({
  id: '/updatePassword',
  path: '/updatePassword',
  getParentRoute: () => SecureRouteRoute,
} as any)
const SecureResetPasswordRoute = SecureResetPasswordRouteImport.update({
  id: '/resetPassword',
  path: '/resetPassword',
  getParentRoute: () => SecureRouteRoute,
} as any)
const SecureLoginRoute = SecureLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => SecureRouteRoute,
} as any)
const FormsIdRoute = FormsIdRouteImport.update({
  id: '/forms/$id',
  path: '/forms/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurePortalRouteRoute = SecurePortalRouteRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => SecureRouteRoute,
} as any)
const SecurePortalIndexRoute = SecurePortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SecurePortalRouteRoute,
} as any)
const SeemeSessionIdAttendeeIdRoute =
  SeemeSessionIdAttendeeIdRouteImport.update({
    id: '/seeme/$sessionId/$attendeeId',
    path: '/seeme/$sessionId/$attendeeId',
    getParentRoute: () => rootRouteImport,
  } as any)
const FormsPreviewIdRoute = FormsPreviewIdRouteImport.update({
  id: '/forms/preview/$id',
  path: '/forms/preview/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/secure': typeof SecureRouteRouteWithChildren
  '/booking': typeof BookingRoute
  '/guidedBooking': typeof GuidedBookingRoute
  '/privacy': typeof PrivacyRoute
  '/secure/portal': typeof SecurePortalRouteRouteWithChildren
  '/forms/$id': typeof FormsIdRoute
  '/secure/login': typeof SecureLoginRoute
  '/secure/resetPassword': typeof SecureResetPasswordRoute
  '/secure/updatePassword': typeof SecureUpdatePasswordRoute
  '/secure/verifyAccount': typeof SecureVerifyAccountRoute
  '/mydocs/': typeof MydocsIndexRoute
  '/secure/': typeof SecureIndexRoute
  '/forms/preview/$id': typeof FormsPreviewIdRoute
  '/seeme/$sessionId/$attendeeId': typeof SeemeSessionIdAttendeeIdRoute
  '/secure/portal/': typeof SecurePortalIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/booking': typeof BookingRoute
  '/guidedBooking': typeof GuidedBookingRoute
  '/privacy': typeof PrivacyRoute
  '/forms/$id': typeof FormsIdRoute
  '/secure/login': typeof SecureLoginRoute
  '/secure/resetPassword': typeof SecureResetPasswordRoute
  '/secure/updatePassword': typeof SecureUpdatePasswordRoute
  '/secure/verifyAccount': typeof SecureVerifyAccountRoute
  '/mydocs': typeof MydocsIndexRoute
  '/secure': typeof SecureIndexRoute
  '/forms/preview/$id': typeof FormsPreviewIdRoute
  '/seeme/$sessionId/$attendeeId': typeof SeemeSessionIdAttendeeIdRoute
  '/secure/portal': typeof SecurePortalIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/secure': typeof SecureRouteRouteWithChildren
  '/booking': typeof BookingRoute
  '/guidedBooking': typeof GuidedBookingRoute
  '/privacy': typeof PrivacyRoute
  '/secure/portal': typeof SecurePortalRouteRouteWithChildren
  '/forms/$id': typeof FormsIdRoute
  '/secure/login': typeof SecureLoginRoute
  '/secure/resetPassword': typeof SecureResetPasswordRoute
  '/secure/updatePassword': typeof SecureUpdatePasswordRoute
  '/secure/verifyAccount': typeof SecureVerifyAccountRoute
  '/mydocs/': typeof MydocsIndexRoute
  '/secure/': typeof SecureIndexRoute
  '/forms/preview/$id': typeof FormsPreviewIdRoute
  '/seeme/$sessionId/$attendeeId': typeof SeemeSessionIdAttendeeIdRoute
  '/secure/portal/': typeof SecurePortalIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/secure'
    | '/booking'
    | '/guidedBooking'
    | '/privacy'
    | '/secure/portal'
    | '/forms/$id'
    | '/secure/login'
    | '/secure/resetPassword'
    | '/secure/updatePassword'
    | '/secure/verifyAccount'
    | '/mydocs/'
    | '/secure/'
    | '/forms/preview/$id'
    | '/seeme/$sessionId/$attendeeId'
    | '/secure/portal/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/booking'
    | '/guidedBooking'
    | '/privacy'
    | '/forms/$id'
    | '/secure/login'
    | '/secure/resetPassword'
    | '/secure/updatePassword'
    | '/secure/verifyAccount'
    | '/mydocs'
    | '/secure'
    | '/forms/preview/$id'
    | '/seeme/$sessionId/$attendeeId'
    | '/secure/portal'
  id:
    | '__root__'
    | '/'
    | '/secure'
    | '/booking'
    | '/guidedBooking'
    | '/privacy'
    | '/secure/portal'
    | '/forms/$id'
    | '/secure/login'
    | '/secure/resetPassword'
    | '/secure/updatePassword'
    | '/secure/verifyAccount'
    | '/mydocs/'
    | '/secure/'
    | '/forms/preview/$id'
    | '/seeme/$sessionId/$attendeeId'
    | '/secure/portal/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SecureRouteRoute: typeof SecureRouteRouteWithChildren
  BookingRoute: typeof BookingRoute
  GuidedBookingRoute: typeof GuidedBookingRoute
  PrivacyRoute: typeof PrivacyRoute
  FormsIdRoute: typeof FormsIdRoute
  MydocsIndexRoute: typeof MydocsIndexRoute
  FormsPreviewIdRoute: typeof FormsPreviewIdRoute
  SeemeSessionIdAttendeeIdRoute: typeof SeemeSessionIdAttendeeIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guidedBooking': {
      id: '/guidedBooking'
      path: '/guidedBooking'
      fullPath: '/guidedBooking'
      preLoaderRoute: typeof GuidedBookingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking': {
      id: '/booking'
      path: '/booking'
      fullPath: '/booking'
      preLoaderRoute: typeof BookingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/secure': {
      id: '/secure'
      path: '/secure'
      fullPath: '/secure'
      preLoaderRoute: typeof SecureRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/secure/': {
      id: '/secure/'
      path: '/'
      fullPath: '/secure/'
      preLoaderRoute: typeof SecureIndexRouteImport
      parentRoute: typeof SecureRouteRoute
    }
    '/mydocs/': {
      id: '/mydocs/'
      path: '/mydocs'
      fullPath: '/mydocs/'
      preLoaderRoute: typeof MydocsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/secure/verifyAccount': {
      id: '/secure/verifyAccount'
      path: '/verifyAccount'
      fullPath: '/secure/verifyAccount'
      preLoaderRoute: typeof SecureVerifyAccountRouteImport
      parentRoute: typeof SecureRouteRoute
    }
    '/secure/updatePassword': {
      id: '/secure/updatePassword'
      path: '/updatePassword'
      fullPath: '/secure/updatePassword'
      preLoaderRoute: typeof SecureUpdatePasswordRouteImport
      parentRoute: typeof SecureRouteRoute
    }
    '/secure/resetPassword': {
      id: '/secure/resetPassword'
      path: '/resetPassword'
      fullPath: '/secure/resetPassword'
      preLoaderRoute: typeof SecureResetPasswordRouteImport
      parentRoute: typeof SecureRouteRoute
    }
    '/secure/login': {
      id: '/secure/login'
      path: '/login'
      fullPath: '/secure/login'
      preLoaderRoute: typeof SecureLoginRouteImport
      parentRoute: typeof SecureRouteRoute
    }
    '/forms/$id': {
      id: '/forms/$id'
      path: '/forms/$id'
      fullPath: '/forms/$id'
      preLoaderRoute: typeof FormsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/secure/portal': {
      id: '/secure/portal'
      path: '/portal'
      fullPath: '/secure/portal'
      preLoaderRoute: typeof SecurePortalRouteRouteImport
      parentRoute: typeof SecureRouteRoute
    }
    '/secure/portal/': {
      id: '/secure/portal/'
      path: '/'
      fullPath: '/secure/portal/'
      preLoaderRoute: typeof SecurePortalIndexRouteImport
      parentRoute: typeof SecurePortalRouteRoute
    }
    '/seeme/$sessionId/$attendeeId': {
      id: '/seeme/$sessionId/$attendeeId'
      path: '/seeme/$sessionId/$attendeeId'
      fullPath: '/seeme/$sessionId/$attendeeId'
      preLoaderRoute: typeof SeemeSessionIdAttendeeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/preview/$id': {
      id: '/forms/preview/$id'
      path: '/forms/preview/$id'
      fullPath: '/forms/preview/$id'
      preLoaderRoute: typeof FormsPreviewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SecurePortalRouteRouteChildren {
  SecurePortalIndexRoute: typeof SecurePortalIndexRoute
}

const SecurePortalRouteRouteChildren: SecurePortalRouteRouteChildren = {
  SecurePortalIndexRoute: SecurePortalIndexRoute,
}

const SecurePortalRouteRouteWithChildren =
  SecurePortalRouteRoute._addFileChildren(SecurePortalRouteRouteChildren)

interface SecureRouteRouteChildren {
  SecurePortalRouteRoute: typeof SecurePortalRouteRouteWithChildren
  SecureLoginRoute: typeof SecureLoginRoute
  SecureResetPasswordRoute: typeof SecureResetPasswordRoute
  SecureUpdatePasswordRoute: typeof SecureUpdatePasswordRoute
  SecureVerifyAccountRoute: typeof SecureVerifyAccountRoute
  SecureIndexRoute: typeof SecureIndexRoute
}

const SecureRouteRouteChildren: SecureRouteRouteChildren = {
  SecurePortalRouteRoute: SecurePortalRouteRouteWithChildren,
  SecureLoginRoute: SecureLoginRoute,
  SecureResetPasswordRoute: SecureResetPasswordRoute,
  SecureUpdatePasswordRoute: SecureUpdatePasswordRoute,
  SecureVerifyAccountRoute: SecureVerifyAccountRoute,
  SecureIndexRoute: SecureIndexRoute,
}

const SecureRouteRouteWithChildren = SecureRouteRoute._addFileChildren(
  SecureRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SecureRouteRoute: SecureRouteRouteWithChildren,
  BookingRoute: BookingRoute,
  GuidedBookingRoute: GuidedBookingRoute,
  PrivacyRoute: PrivacyRoute,
  FormsIdRoute: FormsIdRoute,
  MydocsIndexRoute: MydocsIndexRoute,
  FormsPreviewIdRoute: FormsPreviewIdRoute,
  SeemeSessionIdAttendeeIdRoute: SeemeSessionIdAttendeeIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
